<template>
  <div id='bd-team'>
    我的团队
  </div>
</template>

<script>
export default {
  name: 'bd-team'

}
</script>

<style scoped>

</style>
